module.exports = __webpack_public_path__ + "static/media/midoriya.d662ca88.png";